import Script from 'next/script'
import { FC } from 'react'

const PODSCRIBE_SCRIPT_URL = process.env.NEXT_PUBLIC_PODSCRIBE_URL
const PODSCRIBE_USER_ID = process.env.NEXT_PUBLIC_PODSCRIBE_USER_ID
const PODSCRIBE_ADVERTISER = process.env.NEXT_PUBLIC_PODSCRIBE_ADVERTISER

/* SHA-256 hash utility for email - uses Web Crypto API */
export const hashEmailSHA256 = async (email: string): Promise<string> => {
  if (!email) return ''
  // 非安全上下文(http、部分 in-app webview)下 crypto.subtle 不存在,访问它会抛异常。
  // 跳过哈希而不是抛错,否则下单成功页会多出一条未处理的 rejection(RL-1308)
  if (typeof crypto == 'undefined' || !crypto.subtle) return ''
  const normalizedEmail = email.toLowerCase().trim()
  const encoder = new TextEncoder()
  const data = encoder.encode(normalizedEmail)
  const hashBuffer = await crypto.subtle.digest('SHA-256', data)
  const hashArray = Array.from(new Uint8Array(hashBuffer))
  const hashHex = hashArray.map(b => b.toString(16).padStart(2, '0')).join('')
  return hashHex
}

/* Init Podscribe Script - Site Visit Pixel */
export const PodscribeScript: FC = () => {
  if (!PODSCRIBE_SCRIPT_URL || !PODSCRIBE_USER_ID || !PODSCRIBE_ADVERTISER) {
    return null
  }

  return (
    <Script id='podscribe-script'>{`(function (w, d) {
var id = 'podscribe-capture',
n = 'script';
var e = d.createElement(n);
e.id = id;
e.async = true;
e.src = '${PODSCRIBE_SCRIPT_URL}';
var s = d.getElementsByTagName(n)[0];
s.parentNode.insertBefore(e, s);
e.addEventListener('load', function() {
var tries = 0;
var callInit = function() {
if (typeof w.podscribe === 'function') {
w.podscribe('init', {
user_id: '${PODSCRIBE_USER_ID}',
advertiser: '${PODSCRIBE_ADVERTISER}'
});
w.podscribe('view');
} else if (tries < 10) {
tries++;
setTimeout(callInit, 200);
}
};
callInit();
})
})(window, document);`}</Script>
  )
}

/* Podscribe Purchase Pixel - for order confirmation page */
type PodscribePurchaseProps = {
  value: number
  order_number: string | number
  discount_code: string
  hashed_email: string
}

export const PodscribePurchaseScript: FC<PodscribePurchaseProps> = ({ value, order_number, discount_code, hashed_email }) => {
  if (!PODSCRIBE_SCRIPT_URL || !PODSCRIBE_USER_ID || !PODSCRIBE_ADVERTISER) {
    return null
  }

  return (
    <Script id='podscribe-purchase-script'>{`(function (w, d) {
var id = 'podscribe-capture',
n = 'script';
var e = d.createElement(n);
e.id = id;
e.async = true;
e.src = '${PODSCRIBE_SCRIPT_URL}';
var s = d.getElementsByTagName(n)[0];
s.parentNode.insertBefore(e, s);
e.addEventListener('load', function() {
var tries = 0;
var callInit = function() {
if (typeof w.podscribe === 'function') {
w.podscribe('init', {
user_id: '${PODSCRIBE_USER_ID}',
advertiser: '${PODSCRIBE_ADVERTISER}'
});
w.podscribe('purchase', {
value: ${value},
order_number: '${order_number}',
discount_code: '${discount_code}',
hashed_email: '${hashed_email}',
});
} else if (tries < 10) {
tries++;
setTimeout(callInit, 200);
}
};
callInit();
})
})(window, document);`}</Script>
  )
}

export default PodscribeScript
